import { render, staticRenderFns } from "./FolderArchive.vue?vue&type=template&id=24e84fce"
import script from "./FolderArchive.vue?vue&type=script&lang=js"
export * from "./FolderArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports